import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import { combineReducers } from '@reduxjs/toolkit';
import userReducer from './slices/userSlice';
import companyReducer from './slices/companySlice';

// Persist configuration
const persistConfig = {
  key: 'root',
  storage,
  version: 1,
  whitelist: ['user', 'company'],
};

// Combine reducers
const rootReducer = combineReducers({
  user: userReducer,
  company: companyReducer,
});

// Create persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure store with persisted reducer
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore redux-persist actions (full set - FLUSH/PAUSE/PURGE were
        // missing, so persistor.flush() logged a non-serializable warning).
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

// Create persistor
export const persistor = persistStore(store);

// Wire the store + persistor into the axios layer so its token-expiry
// logout() can clear the persisted Redux auth state (prevents the
// /login <-> /dashboard redirect loop when a stale persisted session
// is rehydrated without a valid Cognito token).
import { setStore, setPersistor } from '../services/axios/ApiConfig';
setStore(store);
setPersistor(persistor);
